<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <provider-form-field
      :label="$t('product.fields.provider')"
      required
      :value="value.provider"
      :disabled="disabled"
      :error="findError('provider')"
      @input="propertyChange('provider', $event)"
    />

    <string-form-field
      :label="$t('product.fields.name')"
      required
      :value="value.name"
      :disabled="disabled"
      :error="findError('name')"
      @input="propertyChange('name', $event)"
    />

    <b-row>
      <number-form-field
        class="col-md-6"
        :label="$t('microCreditProduct.fields.minAmount')"
        required
        :precision="2"
        :value="value.minAmount"
        :disabled="disabled"
        :error="findError('minAmount')"
        @input="propertyChange('minAmount', $event)"
      />

      <number-form-field
        class="col-md-6"
        :label="$t('microCreditProduct.fields.maxAmount')"
        required
        :precision="2"
        :value="value.maxAmount"
        :disabled="disabled"
        :error="findError('maxAmount')"
        @input="propertyChange('maxAmount', $event)"
      />
    </b-row>

    <string-form-field
      :label="$t('product.fields.description')"
      multiline
      :value="value.description"
      :disabled="disabled"
      :error="findError('description')"
      @input="propertyChange('description', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";
import ProviderFormField from "@/modules/provider/protected/ProviderFormField";

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  components: {
    ProviderFormField
  }
};
</script>
